<template>
  <v-app-bar app :color="isDarkMode ? '' : 'white'" flat elevation="3">
    <v-container class="py-0 fill-height">
      <router-link to="/home">
        <img alt="ElevenTickets" :src="image_src1" class="header-image" />
      </router-link>
      <v-btn class="ml-10" rounded text to="/home">
        <v-icon class="mr-2">
          {{ $config.icons.back }}
        </v-icon>
        Voltar
      </v-btn>
      <v-btn class="ml-10" rounded text to="/docs/home">
        <v-icon class="mr-2">
          {{ $config.icons.home }}
        </v-icon>
        Home
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn rounded icon class="base" @click="toggleDarkMode()">
        <v-icon v-if="isDarkMode" class="dark-button">
          {{ $config.icons.dark }}
        </v-icon>
        <v-icon v-else class="dark-button">
          {{ $config.icons.light }}
        </v-icon>
      </v-btn>

      <v-btn
        v-for="link in links"
        :key="link"
        :to="rota"
        text
        class="mr-6 ml-6"
        rounded
      >
        {{ link }}
      </v-btn>
      <div class="searchbar-menu">
        <v-text-field
          placeholder="Search"
          dense
          flat
          hide-details
          rounded
          solo-inverted
          v-model="value"
          @keyup.enter="search()"
        >
          <template slot="append">
            <v-icon color="black">
              {{ $config.icons.search }}
            </v-icon>
          </template>
        </v-text-field>
        <v-col
          cols="12"
          class="subsearch-menu animate__animated animate__fadeIn"
          v-if="value.length > 0"
          v-click-outside="onClickOutside"
        >
          <v-card class="sub-search" elevation="5">
            <v-card
              :class="$vuetify.theme.dark ? 'texts-dark pa-3' : 'texts pa-3'"
              v-for="items in filteredSearch"
              :key="items.title"
              :to="items.link"
              elevation="0"
            >
              {{ items.title }}
              <v-card-subtitle class="sub pa-0">
                {{ items.description }}
              </v-card-subtitle>
            </v-card>
          </v-card>
        </v-col>
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import search from "@/docs/mixins/search.mixins.js";
export default {
  name: "DocumentHeader",
  mixins: [search],
  data: () => ({
    isDarkMode: false,
    value: "",
    links: ["Changelog"],
    rota: "/docs/updates",
    image_src1: "/playground_assets/logo2-1000w.png",
  }),
  methods: {
    toggleDarkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.isDarkMode = !this.isDarkMode;
    },
    onClickOutside() {
      this.value = "";
    },
    search() {
      let search = this.value;
      this.value = "";
      if (
        this.$route.name !== "search" ||
        this.$route.query.search !== search
      ) {
        this.$router.push({
          name: "search",
          query: { search },
        });
      } else if (this.$route.query.search !== search) {
        this.$router.replace({
          query: { search },
        });
      }
    },
  },
  computed: {
    filteredSearch() {
      if (this.isAdmin) {
        var adminResults = this.sessions.filter(
          result =>
            result.title.toLowerCase().includes(this.value.toLowerCase()) ||
            result.description.toLowerCase().includes(this.value.toLowerCase())
        );
      } else if (!this.isAdmin) {
        var lojaResults = this.sessions.filter(
          result =>
            result.user === "loja" &&
            (result.title.toLowerCase().includes(this.value.toLowerCase()) ||
              result.description
                .toLowerCase()
                .includes(this.value.toLowerCase()))
        );
      }
      return this.isAdmin ? adminResults : lojaResults;
    },
    // eslint-disable-next-line vue/return-in-computed-property
    isAdmin() {
      const userType = this.$axios.getLocal("oe_user_info")?.data?.user_type;
      switch (userType) {
        case "admin":
          return true;
        case "loja":
          return false;
        default:
          break;
      }
    },
  },
  watch: {
    $route(e) {
      if (e) {
        this.value = "";
      }
    },
  },
};
</script>
<style scoped>
.header-image {
  width: 28px !important;
  height: 42px !important;
  text-decoration: none;
  transition: 0.2s ease-in-out;
}
.header-image:hover {
  transform: scale(1.03);
}
.dark-button {
  transition: background-color 0.5s, color 0.5s ease-in-out;
}
.searchbar-menu {
  position: relative;
  width: 370px;
  transition: 0.5s ease-in-out;
}
.subsearch-menu {
  position: absolute;
  top: 35px;
  height: auto;
  display: flex;
  width: 600px;
}
.sub-search {
  max-height: 50vh;
  width: 100%;
  overflow: auto;
}
.sub {
  width: 90%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.texts {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.texts:hover {
  background-color: #e5e5e5;
  border-radius: 10px;
}
.texts-dark {
  width: 250px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  transition: 0.4s ease-in-out;
}
.texts-dark:hover {
  background-color: #424242;
  border-radius: 10px;
}
@media (max-width: 1366px) {
  .searchbar-menu {
    width: 260px;
  }
}
</style>
